import React, {useEffect, useState} from "react";
import SectionContentBox from "../SectionContentBox";
import QuestionAccordion from "./QuestionAccording";
import {useLanguage} from "../../hooks/LanguageContext";
import apiService from "../../services/apiService";

const Questions = () => {
	const [data, setData] = useState([]);
	const { direction } = useLanguage(); // Get the direction from LanguageContext

	useEffect(() => {
		apiService
			.getFaqs()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {});
	}, []);

	return (
		<section
			className={`relative container mt-[180px] ${direction === "rtl" ? "text-right" : "text-left"}`}
		>
			<SectionContentBox
				width="w-full"
				justify={"justify-center"}
				align={"items-center"}
				title={direction === "ltr" ? "FAQs" : "الاسئلة الشائعة"}
				hasTowLines={true}
				headline={
					<>
						{direction === "ltr" ? "Answers to Your" : "إجابات على"}{" "}
						<span className="text-primary-700">
              {direction === "ltr" ? "Frequently Asked Questions" : "أسئلتك"}
            </span>{" "}
						{direction === "ltr" ? "FAQ" : "الشائعة"}
					</>
				}
				hideBtn={true}
			/>

			<div className="md:w-[1110px] w-full flex flex-col items-start mx-auto gap-3">
				{data.map((item) => (
					<QuestionAccordion key={item.id} question={direction === 'rtl' ? item.question_ar : item.question_en}>
						{direction === 'rtl' ? item.answer_ar : item.answer_en}
					</QuestionAccordion>
				))}
			</div>
		</section>
	);
};

export default Questions;
